import React from 'react';
import { InputSearch } from '@admitkard/ccl/InputSearch';
import { Text } from '@admitkard/ccl/Text';
import { theme } from '@admitkard/ccl/style';
import { env } from '@admitkard/uiutils/env';
import css from 'styled-jsx/css';

interface SearchProps {
  handleSearch: (value: string) => void;
}

const searchStyles = css`
  .search-container {
    box-sizing: border-box;
    background-image: url(${env.getAssetUrl('images/university_listing.png')});
    background-size: cover;
    background-repeat: no-repeat;
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-top: ${theme.spacingOld(6)};
    padding: ${theme.spacingOld(6)};
  }

  @media ${theme.mediaQuery.mobileUp} {
    .search-container {
      background-position: top -2rem center;
      min-height: 19rem;
      margin-top: 0;
      justify-content: space-evenly;
    }
    .search-bar {
      width: 25rem;
    }
  }
`;

class UniversitySearch extends React.Component<SearchProps> {
  render() {
    const { handleSearch } = this.props;
    return (
      <div className="search-container">
        <Text weight="bold" color="white" variant="h1" align="center">
          Find your Dream Universities here
        </Text>
        <div className="search-bar">
          <InputSearch
            searchIcon="search-white"
            inputPlaceHolder="Search University"
            showLoadingState={false}
            showRemoveButton={true}
            color="primary"
            onSubmitBtnClick={(value) => {
              handleSearch(value);
            }}
            onEnterClick={(value) => {
              handleSearch(value);
            }}
            _id="input-search"
          />
        </div>
        <style jsx>{searchStyles}</style>
      </div>
    );
  }
}

export default UniversitySearch;
